import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentUnitIsRequired extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'data-model.document-item.validation.unit.required');
    }
}
